import { useMediaQuery } from './useMediaQuery';

/** Viewport width (px) below which the app switches to the phone layout. */
export const MOBILE_BREAKPOINT = 768;

/**
 * Returns true on phone-sized viewports (< 768px), where the sidebar becomes an
 * off-canvas drawer and content collapses to a single column.
 */
export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
}
